// Canonical unit-type palette — every learning-time surface (student
// dashboard widget, classroom widget) must use these so a type keeps one
// color everywhere. The admin portal mirrors the same values.
export const unitTypeColors: Record<string, string> = {
	video: '#6C63FF',
	document: '#FF8532',
	test: '#FFD037',
	webinar: '#A0A2FF',
	webcontent: '#36A2EB',
	assignment: '#00CE67',
}

export default unitTypeColors
